import { useParams, Navigate } from 'react-router-dom';

const MOBILE_MAX_WIDTH = 480;

/**
 * Wraps /m/properties/:id routes.
 * On a desktop-width viewport (> 480 px) redirect to the desktop Property 360.
 * On mobile the children render normally.
 */
export default function DesktopRedirect({ children }) {
  const { id } = useParams();

  if (typeof window !== 'undefined' && window.innerWidth > MOBILE_MAX_WIDTH) {
    return <Navigate to={`/modules/clc-properties/properties/${id}`} replace />;
  }

  return children;
}
